import styled from 'styled-components';

export const Container = styled.li`
  position: relative;

  width: 48.5rem;
  height: 12.4rem;

  border-radius: 0.4rem;

  background: #fff;

  margin-right: 4rem;
  margin-bottom: 3rem;

  @media (max-width: 425px) {
    margin-right: 0;
  }
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 15%;

  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 3.2rem;
  justify-content: space-around;
  height: 100%;
`;

export const LineWrapper = styled.div`
  font-size: 1.9rem;
  display: flex;
`;
